import React from 'react';
import { Box } from '@chakra-ui/react';
import LoginForm from '../components/auth/LoginForm';
import HeatZoneBackground from '../components/common/HeatZoneBackground';

export const LoginPage = () => {
  return (
    <Box minH="100vh" position="relative" overflow="hidden">
      <HeatZoneBackground />
      <Box position="relative" zIndex={10} py={10}>
        <LoginForm />
      </Box>
    </Box>
  );
};

export default LoginPage;
